import { css } from "@emotion/react";
import React from "react";
import { HTMLAttributes } from "react";
import { EPortfolioLogo } from "./main-logo";

export interface SubNaviProps extends HTMLAttributes<HTMLElement> {
  isSticky?: boolean;
  onClose?: () => void;
}

export function SubNaviMenu({ isSticky, onClose, ...props }: SubNaviProps) {
  return (
    <ul
      css={(theme) => css`
        margin-top: 3rem;
        display: flex;
        flex-direction: column;
        width: 100%;
        text-align: center;

        & > li:not(:first-of-type),
        & > div {
          margin-top: 1.5rem;
        }

        & > li:not(:last-of-type),
        & > div {
          margin-bottom: 1.5rem;
        }

        @media ${theme.breakpoints.md} {
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          margin-top: unset;

          & > li:not(:first-of-type) {
            margin-top: unset;
            margin-left: 1.5rem;
          }

          & > li:not(:last-of-type) {
            margin-bottom: unset;
            margin-right: 1.5rem;
          }

          & > div > li:first-of-type {
            margin-left: 1.5rem;
          }

          & > div > li:last-of-type {
            margin-right: 1.5rem;
          }
        }
      `}
      {...props}
    >
      <li>
        <a
          href="https://learning-bank.ilas.nagoya-u.ac.jp/users/sign_in"
          target="_blank"
          rel="noopener noreferrer"
        >
          <EPortfolioLogo
            css={(theme) => [
              css`
                width: 9.2rem;
                height: 9.2rem;

                path,
                text {
                  transition: fill 0.4s;
                  fill: ${theme.colors.white};
                }

                @media ${theme.breakpoints.md} {
                  width: 23.8rem;
                  height: 2.8rem;
                }
              `,
              isSticky &&
                css`
                  path,
                  text {
                    fill: ${theme.colors.black};
                  }
                `,
            ]}
          />
        </a>
      </li>
    </ul>
  );
}
